import React from 'react';
import * as api from '../../../api';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import dayjs from 'dayjs';

const CandidaturePreviewContainer = styled.div`
    display: flex;
    background-color:white;
    margin: 10px 10px;
    padding: 15px;
    border-radius: 5px;
    /* align-items: center; */
    position:relative;
    justify-content:space-between;
    & > div {
        width: 70%;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    & > select {
        width: 20%;
        margin: 2.5%;
    }
    & > .linkbutton {
        width: 25%;
        text-align: right;
    }
`

const CandidaturePreview = (props) => {

    const { i18n } = useTranslation('common');
    console.log("props.candidature :")
    console.log(props.candidature)

    //get matching company participation
    const [companyParticipation, setCompanyParticipation] = React.useState(null);
    React.useEffect(() => {
        if(!props.candidature.participationId || !props.participatingCompanies) return;
        setCompanyParticipation(props.participatingCompanies.find((participation) => participation.participation._id === props.candidature.participationId))
    },[props.candidature.participationId,props.participatingCompanies]);

    function setPriority(candidatureId,priority){
        api.SetCandidaturePriority(candidatureId,priority).then((response) => {
            console.log(response.data)
            props.afterUpdateCandidature()
        }).catch((error) => {
            console.log(error);
        });
    }

    function deleteCandidature(candidatureId){
        api.DeleteCandidature({candidatureId : candidatureId}).then((response) => {
            console.log(response.data)
            props.afterUpdateCandidature()
        }).catch((error) => {
            console.log(error);
        });
    }

    return (
        <CandidaturePreviewContainer>
            {companyParticipation && <>
                <div >
                    <b onClick={()=>props.setSelectedCompany(companyParticipation)}>{companyParticipation.hsCompany?.properties?.name}</b><br/>
                    <div>
                        <p className='thin mini' >{companyParticipation.participation.data.presentiel === "oui" && (dayjs(props.event.main_date).format('dddd D MMMM YYYY') +" - "+ props.event.localisation)}{companyParticipation.participation.data.presentiel === "non" && (dayjs(props.event.online_date).format('dddd D MMMM YYYY') +" - "+ (i18n.language === "fr" ? "En ligne" : "Online"))}</p>
                        {/* <i className='thin mini'>{companyParticipation.participation.data.numTableOULienZoom}</i> */}
                    </div><br/>
                    <p className='thin'>{i18n.language === "fr" ? companyParticipation.participation.data.description_admin_fr : companyParticipation.participation.data.description_admin_en}</p>
                </div>
                <div className='candidature_buttons'>
                    {companyParticipation.company.logo && <img alt="" className='logosized centered' src={process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + companyParticipation.company.logo}/>}<br/>
                    <i className='centered'>{i18n.language === "fr" ? "Priorité" : "Priority"}</i>
                    <select style={{outline:"none"}} value={props.candidature.priorite} onChange={(e) => setPriority(props.candidature._id,e.target.value)}>
                        <option value="">{i18n.language === "fr" ? "Selectionnez" : "Select"}</option>
                        {props.allCandidatures.map((c,i) => 
                            <option key={i} value={i + 1}>{i + 1}</option>
                        )}
                    </select><br/>
                    <button style={{fontSize: "10px"}} className='red_button' onClick={()=>deleteCandidature(props.candidature._id)}>{i18n.language === "fr" ? "Supprimer" : "Delete"}</button><br/>
                    <button style={{fontSize: "10px"}} onClick={()=>props.setSelectedCompany(companyParticipation)}>{i18n.language === "fr" ? "Plus d'informations" : "More information"}</button>
                </div>
            </>}
        </CandidaturePreviewContainer>
    );
};

export default CandidaturePreview;